import { render, staticRenderFns } from "./attrInfo.vue?vue&type=template&id=d5abad96&scoped=true"
import script from "./attrInfo.vue?vue&type=script&lang=js"
export * from "./attrInfo.vue?vue&type=script&lang=js"
import style0 from "./attrInfo.vue?vue&type=style&index=0&id=d5abad96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5abad96",
  null
  
)

export default component.exports